import { locale } from "@/locale";
import { cn } from "@pulsex/utils";
import Link from "next/link";
import React from "react";
import { authorHref } from "@/utils/links";
import { getPostAuthors } from "@/utils/getPostAuthors";

// Pass `post` to list every author of a post (main author and co-authors);
// `item` renders a single author object.
type AuthorProps = { item?: any; post?: any; className?: string };

const Author = ({ item, post, className }: AuthorProps) => {
  const authors = post
    ? getPostAuthors(post)
    : item?.name
    ? [item]
    : [];

  if (!authors.length) {
    return (
      <div
        className={cn("text-sm w-fit cursor-pointer text-minorTheme", className)}
      >
        {locale.akhbar}
      </div>
    );
  }

  return (
    <div className={cn("text-sm w-fit text-minorTheme", className)}>
      {authors.map((author, index) => (
        <React.Fragment key={author.id || author.name}>
          {index > 0 && "، "}
          <Link href={authorHref(author.id, " ")} className="cursor-pointer">
            {author.name}
          </Link>
        </React.Fragment>
      ))}
    </div>
  );
};

export default Author;
